import React, { Component } from "react";
import ReactDOM from "react-dom";
import { dp } from "../../../utils/shared.js";
import ReactIScroll from "react-iscroll";
import iScroll from "iscroll";
import Slider from "react-slick";
import MenuOmaha from "./MenuOmaha";
import _ from "lodash";
import { connect } from "react-redux";
// import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

const QuillDeltaToHtmlConverter = require("quill-delta-to-html");
class StoryOmaha extends Component {
  constructor(props) {
    super(props);
    this._story = null;
    this._background = null;
    this._slickRef = null;
    this._slides = [];
    this._imagesStatus = [];
    this._imagesVerificationInitialized = false;
    this._totalSlides = 0;
    this._handIconRef = null;
    this._headlineRef = null;
    this._backButtonRef = null;
    this._background = null;
    this._icon = null;

    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');     
    const rootFolderModule = this.props.content.folder_modules.find(s => s.id === Number(id));
    const rootFolder = this.props.content.stories.find(s => s.id === rootFolderModule.module_id);

    this.setupElements(rootFolder);
    this.getSlides();

    this.state = {
      rootFolder,
      rootFolderModule,
      handOpacity: 0,
      handPositionX: 0,
      handPositionY: 0,
      imagesLoaded: false,
      changeHeadlineFontSize: false
    };
  }  

  componentDidMount() {
    this._background = this.getBackgroundImage();
    this._icon = this.getIcon();
    if (this._totalSlides > 0) {
      this.verifyThatImagesAreLoaded();
    }

    this.checkHeadlineSize();
    this.setRefs();
  }

  setRefs = () => {
    if (!this._backButtonRef) {
      setTimeout(() => {
        this.setRefs();
      }, 100);
    } else {
      this._backButtonRef.addEventListener("click", this.goBack);
    }
  };

  goBack = () => {
    const parentFolderId = this.state.rootFolderModule.folder;

    const stories = this.props.content.folder_modules.filter(fm => fm.folder === Number(parentFolderId));
    const childStoryCategories = this.props.content.story_categories.filter(
      (sc) => sc.parent_category === Number(parentFolderId)
    );
    const activeModules = _.filter(this.props.content.dm_active, dm => dm.module_contents.in_navigation);

    const displayModule = _.find(activeModules, {
      display_module_type: "Stories",
      contents: { story_category: parentFolderId.toString() }
    });

    const total = stories.length + childStoryCategories.length;

    if (total === 1) {
      if (stories.length === 1) {
        this.props.navRoute("/omaha/nav");
      } else {
        this.props.navRoute("/omaha/stories", displayModule);
      }        
    } else {
      this.props.navRoute("/omaha/stories", displayModule);
    }
  };

  checkHeadlineSize = () => {
    if (!this._headlineRef) {
      setTimeout(() => {
        this.checkHeadlineSize();
      }, 100);
    } else {
      let maxAllowed = (this.props.screen.screenHeight * 37.83) / 100;
      let width = this._headlineRef.getBoundingClientRect().width;

      if (width > maxAllowed) {
        this.setState({
          changeHeadlineFontSize: true,
          headlineFontSize: (this.props.screen.screenHeight * 3) / 100
        });
      }
    }
  };

  verifyThatImagesAreLoaded = () => {
    if (!this._imagesVerificationInitialized) {
      this._imagesStatus = Array.apply(null, { length: this._totalSlides }).map((value) => {
        return null;
      });
      this._imagesVerificationInitialized = true;
    }

    let hasLoaded = true;
    for (let i = 0; i < this._totalSlides; i++) {
      if (this._imagesStatus[i] === null) {
        hasLoaded = false;
        break;
      }
    }

    if (!hasLoaded) {
      this._handleImageVerificationTimeout = setTimeout(() => {
        this.verifyThatImagesAreLoaded();
      }, 100);
    } else {
      this._imagesLoaded = true;
      this.initializeHandPosition();
    }
  };

  initializeHandPosition = () => {
    let storySlick = ReactDOM.findDOMNode(this._slickRef).getElementsByClassName("story-slick");
    if (storySlick.length > 0) {
      if (storySlick[0].childNodes[0]) {
        let firstBullet = storySlick[0].childNodes[0].getBoundingClientRect();
        this.setState({
          handPositionX: firstBullet.x - this.props.screen.screenHeight * 0.03 * 1.25,
          handPositionY: firstBullet.y * 1.0212,
          handOpacity: 1,
          imagesLoaded: true
        });
      }
    }
  };

  setupElements = (rootFolder) => {
    let background = dp(this.props.screen, null, { path: "/img/omaha/general/", file_name: "story-background.jpg" });
    this._story = rootFolder;
    this._background = background;
    this._headLine = this.props.module.name.toUpperCase();
    if (_.has(this.props.module, "overrideStoryName")) {
      this._headLine = this.props.module.overrideStoryName;
    }
    let handIcon = dp(this.props.screen, null, { path: "/img/ui/", file_name: "handIconSwipe.png" });
    this._handIcon = handIcon;

    this.setState({ rootFolder });
  };

  getSlides = () => {
    let images = this._story.contents.images;
    let occupiedSlots = _.filter(images, (img) => {
      return img !== null;
    });
    let slides = [];

    for (let i = 0; i < occupiedSlots.length; i++) {
      if (occupiedSlots[i]) {
        this._totalSlides++;
      }
    }

    if (occupiedSlots.length > 0) {
      slides = occupiedSlots.map((media, i) => {
        if (media) {
          return (
            <div key={i} style={{ display: "table" }}>
              <div style={{ display: "table-cell", verticalAlign: "middle", height: "28vh" }}>
                <img
                  style={{
                    maxWidth: "38vh",
                    maxHeight: "28vh",
                    display: "table-cell",
                    verticalAlign: "middle",
                    margin: "auto"
                  }}
                  src={dp(this.props.screen, media, null)}
                  onLoad={() => (this._imagesStatus[i] = true)}
                  onError={() => (this._imagesStatus[i] = false)}
                  alt=""
                />
              </div>
            </div>
          );
        }

        return <span />;
      });
    }

    this._slides = slides;
  };

  getBackgroundImage = () => {
    let defaultImg = { path: "/img/omaha/general/", file_name: "story-background.jpg" };

    if (this.props.screensNumber === 2) {
      defaultImg.file_name = "default_double_screen.jpg";
    }

    try {
      let backgroundReference = this.props.module.contents.custom_fields.background_reference_story_view.val;
      let assetsSlideShow = _.find(this.props.content.dm_active, function (o) {
        return o.name.includes("Assets");
      });
      let asset = _.indexOf(assetsSlideShow.contents.names, backgroundReference);

      if (!asset || asset === undefined) {
        return dp(this.props.screen, defaultImg);
      }

      return dp(this.props.screen, assetsSlideShow.contents.images[asset]);
    } catch (e) {
      return dp(this.props.screen, defaultImg);
    }
  };

  getIcon = () => {
    let category = this.props.module.folder;
    let foundDm = _.filter(this.props.content.dm_active, (dm) => {
      return Number(dm.contents.story_category) === category;
    });

    let icon = null;
    if (foundDm.length > 0) {
      icon = foundDm[0].module_contents.icon;
    }

    return dp(this.props.screen, icon);
  };

  render() {
    try {
      let settings = {
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        useCSS: true,
        dots: true,
        dotsClass: "story-slick"
      };

      let slides = this._slides;
      if (slides.length <= 1) {
        settings.dots = false;
      }

      // const icon = this.getIcon();
      const backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;
      // const backgroundImage = this.getBackgroundImage();
      const textShadow = "0.30vh 0.30vh 0.54vh rgba(51, 51, 51, 0.76)";
      const backButton = dp(this.props.screen, null, { path: "/img/omaha/general/", file_name: "back_grey.png" });
      let headlineFontSize = "3.5vh";
      if (this.state.changeHeadlineFontSize) {
        headlineFontSize = this.state.headlineFontSize;
      }

      let textOps = _.get(this._story.contents.custom_fields, "body.val.ops", {});
      let converter = new QuillDeltaToHtmlConverter(textOps, {});
      let richText = converter.convert();

      return (
        <div
          style={{
            height: this.props.screen.r9_16.height,
            textAlign: "center",
            width: "100%",
            backgroundSize: backgroundSize,
            backgroundImage: "url(" + this._background + ")"
          }}
        >
          <div
            style={{
              backgroundColor: "#8c827a",
              height: "7.16vh",
              width: "100%",
              position: "absolute",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <span
              ref={(el) => (this._headlineRef = el)}
              style={{
                textShadow: textShadow,
                fontSize: headlineFontSize,
                fontWeight: "bold",
                marginTop: "1.83vh",
                marginBottom: "1.83vh"
              }}
            >
              {this._headLine}
            </span>
            <img
              className="shadowed-image"
              style={{ position: "absolute", maxHeight: "5.3vh", right: "1vh", top: "1vh" }}
              src={this._icon}
              alt=""
            />
          </div>
          <div>
            {slides.length > 1 && this.state.imagesLoaded ? (
              <img
                ref={(el) => (this._handIconRef = el)}
                src={this._handIcon}
                style={{
                  opacity: this.state.handOpacity,
                  left: this.state.handPositionX,
                  top: this.state.handPositionY,
                  position: "absolute",
                  width: "2.4vh"
                }}
                alt="hand-icon"
              />
            ) : null}
          </div>
          {this._story.contents.headline && this._story.contents.headline.length > 0 ? (
            <div
              style={{
                position: "absolute",
                fontSize: "2.3vh",
                color: "#6f6259",
                width: "100%",
                height: "20vh",
                top: "11vh",
                textTransform: "uppercase",
                textAlign: "left",
                fontWeight: "bold"
              }}
            >
              <div style={{ position: "relative", width: "39.37vh", margin: "auto" }}>
                <span>{this._story.contents.headline}</span>
              </div>
            </div>
          ) : null}

          {slides.length === 0 ? null : (
            <div style={{ position: "absolute", width: "100%", height: "46.73vh", top: "20vh" }}>
              <div style={{ position: "relative", width: "39.37vh", margin: "auto" }}>
                <Slider ref={(el) => (this._slickRef = el)} {...settings}>
                  {slides}
                </Slider>
              </div>
            </div>
          )}

          <div
            className="gradient"
            style={{ position: "absolute", top: "54vh", height: "40.7vh", width: "100%", touchAction: "none" }}
          >
            <ReactIScroll
              ref={(el) => (this.iScroller = el)}
              iScroll={iScroll}
              options={{
                mouseWheel: true,
                scrollbars: false,
                scrollX: false,
                scrollY: true,
                probeType: 2,
                bounce: false,
                momentum: true,
                deceleration: 0.015,
                useTransition: true,
                disableTouch: false,
                disablePointer: false,
                disableMouse: false,
                tap: true
              }}
            >
              <div style={{ position: "relative", display: "flex", justifyContent: "center" }}>
                <div style={{ width: "39.37vh", display: "flex" }}>
                  <span style={{ fontSize: "1.5vh", textAlign: "left", lineHeight: "3vh", color: "#6f6259" }}>
                    <div className="ql-editor" dangerouslySetInnerHTML={{ __html: richText }}></div>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </div>
              </div>
            </ReactIScroll>
          </div>

          <img
            ref={(el) => (this._backButtonRef = el)}
            src={backButton}
            style={{ position: "absolute", left: "1.3vh", bottom: "8vh", width: "2.8vh" }}
            alt=""
          />

          <div style={{ position: "absolute", bottom: "0vh", width: "100%" }}>
            <MenuOmaha navRoute={this.props.navRoute} currentModuleId={this._story.display_module_id} />
          </div>
        </div>
      );
    } catch (e) {
      console.log(e);
      return <div></div>;
    }
  }
}

const mapStateToProps = (state) => {
  let active_module = state.active_module;
  return {
    active_module: active_module,
    content: state.content
  };
};

export default connect(mapStateToProps)(StoryOmaha);



// WEBPACK FOOTER //
// ./src/Components/Theme/Omaha/StoryOmaha.jsx